<template>
  <CSidebar
    color-scheme="light"
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
  
    <CSidebarBrand class="d-md-down-none" to="/">
      <CRow class="mb-2 m-2">
        <CCol sm="6">
          <img
        src="../assets/img/logobig.png"
        name="logo"
        size="custom-size"
        style="max-width:70%"
      />
    
        </CCol>
        <CCol sm="6" class="text-right">
          <img
        src="../assets/img/grid.png"
        name="logo"
        width="30px"
        class="mt-2"
      />
        </CCol>
        <CCol sm="12" class="mt-3">
          
          
          
          <!-- <div class="input-container">
            <img src="../assets/img/search.png" alt="search icon" class="icon-left" />
            <input type="text" placeholder="Search..." />
            <img src="../assets/img/Command.png" alt="command icon" class="icon-right" />
          </div> -->

        </CCol>
      </CRow>
      <br />
      
    </CSidebarBrand>
    <!-- <div class="bg-white mt-3">
      <div class="text-right">
      <label class="text-right text-danger" v-on:click="SignOut()"
        >Logout</label
      > <CIcon
        name="cil-lock-locked text-black"
        v-on:click="SignOut()"
        class="float-left mr-0"
        title="Logout"
      /> 
    </div>
    </div> -->
 
    <CRenderFunction flat :content-to-render="selectedNavigationMenu" />
    <!-- <div class="bg-white">
      <div class="m-2 text-center">
      <label class="text-center ml-1 text-danger" v-on:click="SignOut()"
        >Logout</label
      > <CIcon
        name="cil-lock-locked text-black"
        v-on:click="SignOut()"
        class="float-left mr-0"
        title="Logout"
      /> 
    </div>
    </div> -->

    <!-- <CRenderFunction flat :content-to-render="$options.nav" /> -->

    <!-- <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    /> -->
  </CSidebar>
</template>

<script>
import nav from "./_nav";
import navTutor from "./_navTutor";
import backgroundUrl from "../assets/img/img.png";

export default {
  name: "TheSidebar",
  nav,
  navTutor,
  data() {
    return {
      backgroundUrl,
      selectedNavigationMenu: [],
      user: {}
    };
  },
  mounted() {
    this.GetProfilePicture();
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.$router.push("/Login");
          }
        });
    },
  },
  methods: {
    GetProfilePicture() {
      this.$API
        .get(this.$ViewProfilePictureAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.user = response.data;
            this.getNavigationMenu(this.user.Id);
          }
        });
    },
    getNavigationMenu(Id) {
      switch (Id) {
        case 1020:
          this.selectedNavigationMenu = this.$options.nav;
          break;
        case 2075:
          this.selectedNavigationMenu = this.$options.nav;
          break;
        default:
          this.selectedNavigationMenu = this.$options.navTutor;
          break;
      }
    },
  },
};
</script>
